import { render } from "./mEnterpriseDynamics.vue?vue&type=template&id=b2f31796&scoped=true"
import script from "./mEnterpriseDynamics.vue?vue&type=script&lang=js"
export * from "./mEnterpriseDynamics.vue?vue&type=script&lang=js"

import "./mEnterpriseDynamics.vue?vue&type=style&index=0&id=b2f31796&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f31796"]])

export default __exports__